@if (!utils.mobileViewActive) {
    <ng-container [ngTemplateOutlet]="dashboard"></ng-container>
} @else {
    <ion-grid class="dp-g-fab fixed h-end bottom mobile-buttons" *ngIf="utils.isPhone && mode == 'manage'">
        <ion-row *ngIf="!searchActive; else projectSearchActiveFabs">
            <ion-col>
                <ion-button class="dp-g-fab-btn" shape="round" size="small" (click)="mapViewEnabled = true">
                    <fa-icon [icon]="['fal', 'map']" slot="icon-only"></fa-icon>
                </ion-button>
            </ion-col>
            <ion-col>
                <ion-button class="dp-g-fab-btn" shape="round" size="small" (click)="toggleSearch()">
                    <fa-icon [icon]="['fal', 'search']" slot="icon-only"></fa-icon>
                </ion-button>
            </ion-col>
            <ion-col>
                <ion-button
                    color="primary"
                    class="dp-g-fab-btn"
                    shape="round"
                    size="small"
                    dpTooltip
                    tooltipTrigger="click mouseenter focus"
                    tooltipTheme="light"
                    tooltipPosition="top"
                    tooltipInteractive="true"
                    hideTooltipAfterInteraction="true"
                    [tooltipContent]="projectSortingDropdown"
                >
                    <fa-icon slot="icon-only" icon="sort-alpha-down"></fa-icon>
                </ion-button>
            </ion-col>
            <ion-col>
                <ion-button
                    class="dp-g-fab-btn"
                    shape="round"
                    (click)="startScanSearch()"
                    [size]="managementChangesAllowed ? 'small' : 'large'"
                >
                    <fa-icon [icon]="['fal', 'qrcode']" slot="icon-only"></fa-icon>
                </ion-button>
            </ion-col>
            <ion-col *ngIf="managementChangesAllowed">
                <ion-button class="dp-g-fab-btn" shape="round" color="success" routerLink="/new-project">
                    <fa-icon [icon]="['fal', 'plus']" slot="icon-only"></fa-icon>
                </ion-button>
            </ion-col>
        </ion-row>
        <ng-template #projectSearchActiveFabs>
            <ion-row>
                <ion-col>
                    <ion-button class="dp-g-fab-btn" shape="round" color="danger" (click)="toggleSearch()">
                        <fa-icon [icon]="['fal', 'times']" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
        </ng-template>
    </ion-grid>
    <ng-container [ngTemplateOutlet]="dashboard"></ng-container>
}

<ng-template #projectSortingDropdown>
    <div class="dropdown-links">
        <ion-list class="bg-white">
            <ion-item class="no-padding bg-white" button (click)="onChangeProjectSortingMode('name-a-z')">
                <fa-icon icon="sort-alpha-down" class="color-black dp-mr-s"></fa-icon>
                <ion-label>{{ 'dashboard.projects.toolbar.sort.name-asc' | translate }}</ion-label>
            </ion-item>
            <ion-item class="no-padding bg-white" button (click)="onChangeProjectSortingMode('name-z-a')">
                <fa-icon icon="sort-alpha-down-alt" class="color-black dp-mr-s"></fa-icon>
                <ion-label>{{ 'dashboard.projects.toolbar.sort.name-desc' | translate }}</ion-label>
            </ion-item>
            <ion-item class="no-padding bg-white" button (click)="onChangeProjectSortingMode('project-number-1-9')">
                <fa-icon icon="sort-numeric-down" class="color-black dp-mr-s"></fa-icon>
                <ion-label>{{ 'dashboard.projects.toolbar.sort.number-asc' | translate }}</ion-label>
            </ion-item>
            <ion-item class="no-padding bg-white" button (click)="onChangeProjectSortingMode('project-number-9-1')">
                <fa-icon icon="sort-numeric-down-alt" class="color-black dp-mr-s"></fa-icon>
                <ion-label>{{ 'dashboard.projects.toolbar.sort.number-desc' | translate }}</ion-label>
            </ion-item>
        </ion-list>
    </div>
</ng-template>

<ng-template #dashboard>
    <ion-card class="dashboard-project-list">
        <ion-card-header>
            <ion-toolbar class="project-list-toolbar" color="none">
                <div class="folder-breadcrumb-wrap">
                    <ion-chip
                        class="folder-breadcrumb-chip"
                        (click)="loadInitialView()"
                        pDroppable
                        [pDroppableDisabled]="mode !== 'manage' || !managementChangesAllowed"
                        (onDrop)="onDropItemOnFolder(null)"
                    >
                        <ng-container *ngIf="searchActive"
                            >{{ 'dashboard.projects.toolbar.navigation.root-search-results' | translate }}
                        </ng-container>
                        <ng-container *ngIf="!searchActive"
                            >{{ 'dashboard.projects.toolbar.navigation.root-all-projects' | translate }}
                        </ng-container>
                    </ion-chip>
                    <ng-container *ngFor="let entry of currentFolderPath; index as entryIndex">
                        <span class="folder-breadcrumb-divider"> / </span>
                        <ion-chip
                            class="folder-breadcrumb-chip"
                            (click)="navigateToFolderViaBreadcrumb(entryIndex)"
                            pDroppable
                            [pDroppableDisabled]="mode !== 'manage' || !managementChangesAllowed"
                            (onDrop)="onDropItemOnFolder(entry)"
                            >{{ entry.name }}
                        </ion-chip>
                    </ng-container>
                </div>

                <ion-buttons slot="end" *ngIf="isDokuPitSupportAccount" class="dp-mr-m">
                    <ion-button fill="solid" color="primary" (click)="showDokuPitSupportProjectList()">
                        <fa-icon icon="list" slot="start"></fa-icon>
                        {{ 'dashboard.support-mode.project-download' | translate }}
                    </ion-button>
                </ion-buttons>
                <ion-buttons slot="end" *ngIf="mode === 'select' || mode === 'multi-select' || !utils.isPhone">
                    <ion-button
                        (click)="mapViewEnabled = true"
                        color="primary"
                        fill="clear"
                        class="round dp-mr-s"
                        dpTooltip
                        [tooltipContent]="'dashboard.projects.toolbar.map' | translate"
                    >
                        <fa-icon slot="icon-only" [icon]="['fal', 'map']"></fa-icon>
                    </ion-button>
                    <ion-button
                        *ngIf="!searchActive"
                        (click)="toggleSearch()"
                        color="primary"
                        fill="clear"
                        class="round dp-mr-s"
                        dpTooltip
                        [tooltipContent]="'dashboard.projects.toolbar.search' | translate"
                    >
                        <fa-icon *ngIf="!searchActive" slot="icon-only" [icon]="['fal', 'search']"></fa-icon>
                        <fa-icon *ngIf="searchActive" slot="icon-only" [icon]="['far', 'times']"></fa-icon>
                    </ion-button>
                </ion-buttons>
                <ion-buttons slot="end" *ngIf="!utils.isPhone && mode == 'manage'">
                    <!-- SORTING ACTIONS -->
                    <ion-button
                        fill="clear"
                        color="primary"
                        class="round dp-mr-s"
                        dpTooltip
                        tooltipTrigger="click mouseenter focus"
                        tooltipTheme="light"
                        tooltipPosition="bottom"
                        tooltipInteractive="true"
                        hideTooltipAfterInteraction="true"
                        [tooltipContent]="projectSortingDropdown"
                    >
                        <fa-icon slot="icon-only" icon="sort-alpha-down"></fa-icon>
                    </ion-button>
                    <!-- QR CODE SCAN -->
                    <ion-button
                        class="round dp-mr-s"
                        fill="clear"
                        color="primary"
                        dpTooltip
                        [tooltipContent]="'dashboard.projects.toolbar.scan-search' | translate"
                        (click)="startScanSearch()"
                    >
                        <fa-icon slot="icon-only" icon="qrcode"></fa-icon>
                    </ion-button>
                    <ion-button
                        size="small"
                        fill="solid"
                        color="primary"
                        class="new-project-folder-button round"
                        style="margin-left: 12px; margin-right: 5px"
                        dpTooltip
                        (click)="onCreateNewFolder(newFolderActn)"
                        [tooltipContent]="'dashboard.projects.toolbar.add-folder' | translate"
                        *ngIf="managementChangesAllowed && !utils.isTablet"
                        #newFolderActn
                    >
                        <fa-icon icon="folder-plus" slot="icon-only"></fa-icon>
                    </ion-button>
                    <ion-button
                        routerLink="/new-project"
                        size="large"
                        fill="solid"
                        color="primary"
                        *ngIf="managementChangesAllowed"
                        class="new-project-button"
                    >
                        <fa-icon icon="plus" slot="start"></fa-icon>
                        <ion-label>{{ 'dashboard.projects.toolbar.new-project' | translate }}</ion-label>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
            <ng-container *ngIf="searchActive">
                <ion-toolbar color="none">
                    <ion-searchbar
                        showClearButton="never"
                        showCancelButton="never"
                        [placeholder]="'dashboard.projects.toolbar.search' | translate"
                        color="light"
                        (ionInput)="handleSearch($event)"
                        (ionCancel)="toggleSearch(false)"
                        (ionClear)="toggleSearch(false)"
                        [debounce]="500"
                        #projectSearchBarInput
                    ></ion-searchbar>
                    <ion-button color="danger" fill="solid" class="round dp-mr-m" slot="end" (click)="toggleSearch()">
                        <fa-icon icon="times" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-toolbar>
            </ng-container>
        </ion-card-header>
        <ion-card-content class="dp-pt-0">
            <ng-container *ngIf="loading && syncInfo?.currentSyncWarning != 'first-time-sync'">
                <ion-list>
                    <ion-item>
                        <ion-thumbnail slot="start" class="dp-skeleton-thumbnail">
                            <div class="dp-skeleton" style="width: 40px; height: 40px; border-radius: 50%"></div>
                        </ion-thumbnail>
                        <ion-label>
                            <div class="dp-skeleton dp-mb-s" style="width: 60%; height: 20px"></div>
                            <div class="dp-skeleton" style="width: 40%; height: 14px"></div>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-thumbnail slot="start" class="dp-skeleton-thumbnail">
                            <div class="dp-skeleton" style="width: 40px; height: 40px; border-radius: 50%"></div>
                        </ion-thumbnail>
                        <ion-label>
                            <div class="dp-skeleton dp-mb-s" style="width: 40%; height: 20px"></div>
                            <div class="dp-skeleton" style="width: 60%; height: 14px"></div>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-thumbnail slot="start" class="dp-skeleton-thumbnail">
                            <div class="dp-skeleton" style="width: 40px; height: 40px; border-radius: 50%"></div>
                        </ion-thumbnail>
                        <ion-label>
                            <div class="dp-skeleton dp-mb-s" style="width: 40%; height: 20px"></div>
                            <div class="dp-skeleton" style="width: 25%; height: 14px"></div>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-thumbnail slot="start" class="dp-skeleton-thumbnail">
                            <div class="dp-skeleton" style="width: 40px; height: 40px; border-radius: 50%"></div>
                        </ion-thumbnail>
                        <ion-label>
                            <div class="dp-skeleton dp-mb-s" style="width: 70%; height: 20px"></div>
                            <div class="dp-skeleton" style="width: 50%; height: 14px"></div>
                        </ion-label>
                    </ion-item>
                </ion-list>
            </ng-container>
            <ng-container *ngIf="!loading && syncInfo?.currentSyncWarning == 'first-time-sync'">
                <ion-card class="current-sync-warning ion-text-center" color="warning">
                    <ion-card-header>
                        <ion-card-title>
                            <fa-icon icon="exclamation-circle"></fa-icon>
                            {{ 'dashboard.sync-info.first-time-title' | translate }}
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div class="dp-mb-s" [innerHTML]="'dashboard.sync-info.first-time-message' | translate"></div>
                        <app-loading-indicator>
                            {{ 'dashboard.sync-info.first-time-downloads' | translate: { count: syncInfo.currentRunDownstreamCount } }}
                        </app-loading-indicator>
                    </ion-card-content>
                </ion-card>
            </ng-container>

            <ng-container *ngIf="!loading && syncInfo.currentSyncWarning != 'first-time-sync'">
                <div class="project-list">
                    <cdk-virtual-scroll-viewport
                        *ngIf="combinedListItems.length > 0"
                        [itemSize]="utils.mobileViewActive ? 80 : 60"
                        class="project-list-viewport"
                        #projectListScroll
                    >
                        <ng-container *cdkVirtualFor="let item of combinedListItems">
                            @if (item.type === 'project-folder') {
                                <ion-item
                                    class="project-list-item project-folder"
                                    pDroppable
                                    [pDroppableDisabled]="mode !== 'manage' || !managementChangesAllowed"
                                    (click)="onFolderClicked($any(item))"
                                    (onDrop)="onDropItemOnFolder($any(item))"
                                    [cdkContextMenuTriggerFor]="templateContextMenuFolder"
                                    [cdkContextMenuTriggerData]="{ $implicit: { data: item, anchor: folderAnchor } }"
                                    [cdkContextMenuDisabled]="!managementChangesAllowed || platform.is('ios') || mode !== 'manage'"
                                    (touchstart)="onFolderLongPress($event, item, folderAnchor)"
                                    (touchend)="onLongPressEnd($event)"
                                    (touchmove)="onLongPressEnd($event)"
                                    button
                                    #folderAnchor
                                >
                                    <div
                                        class="project-list-item-inner"
                                        pDraggable
                                        [pDraggableDisabled]="
                                            mode !== 'manage' || utils.isPhone || utils.isTablet || !managementChangesAllowed
                                        "
                                        (onDragStart)="onStartDragItem(item)"
                                        style="cursor: grab"
                                    >
                                        <div class="project-list-item-icon-wrap">
                                            <fa-icon icon="folder" class="project-list-folder-icon"></fa-icon>
                                        </div>
                                        <div class="project-list-item-content">
                                            {{ item.name }}
                                            <div class="project-folder-choose-action" *ngIf="mode === 'select-folder'">
                                                <ion-button (click)="onFolderSelectedAsMoveTarget(item)"
                                                    >{{ 'shared.select' | translate }}
                                                </ion-button>
                                            </div>
                                            <div class="project-list-sync-icon" *ngIf="!item.synced">
                                                <fa-icon icon="cloud-arrow-up"></fa-icon>
                                            </div>
                                        </div>
                                    </div>
                                </ion-item>
                            } @else {
                                <ion-item
                                    class="project-list-item project"
                                    [class.multi-select-active]="mode === 'multi-select' && isProjectSelected(item._id)"
                                    (click)="onProjectClicked($any(item))"
                                    [cdkContextMenuTriggerFor]="templateContextMenuProject"
                                    [cdkContextMenuTriggerData]="{ $implicit: { data: item, anchor: projectAnchor } }"
                                    [cdkContextMenuDisabled]="!managementChangesAllowed || platform.is('ios') || mode !== 'manage'"
                                    (touchstart)="onProjectLongPress($event, item, projectAnchor)"
                                    (touchend)="onLongPressEnd($event)"
                                    (touchmove)="onLongPressEnd($event)"
                                    button
                                    #projectAnchor
                                >
                                    <div
                                        class="project-list-item-inner"
                                        pDraggable
                                        [pDraggableDisabled]="
                                            mode !== 'manage' || utils.isPhone || utils.isTablet || !managementChangesAllowed
                                        "
                                        (onDragStart)="onStartDragItem(item)"
                                        style="cursor: grab"
                                    >
                                        <ion-checkbox
                                            *ngIf="mode === 'multi-select'"
                                            [checked]="isProjectSelected(item._id)"
                                            (click)="$event.stopPropagation()"
                                            (ionChange)="onProjectClicked($any(item))"
                                            class="multi-select-checkbox"
                                        ></ion-checkbox>
                                        <div
                                            class="project-list-item-icon-wrap"
                                            *ngIf="authSrv.authInfo.companyData.companySettings.allowProjectPhoto"
                                        >
                                            <ion-thumbnail
                                                class="project-image ion-display-flex ion-align-items-center ion-justify-content-center"
                                                slot="start"
                                            >
                                                <app-attachment-view
                                                    *ngIf="$any(item).projectImage"
                                                    [showImageWithoutStyles]="true"
                                                    [attachment]="$any(item).projectImage"
                                                    [canDelete]="false"
                                                    [loadThumb]="true"
                                                ></app-attachment-view>
                                                <fa-icon
                                                    *ngIf="!$any(item).projectImage"
                                                    icon="image"
                                                    class="project-image-placeholder"
                                                ></fa-icon>
                                            </ion-thumbnail>
                                        </div>
                                        <div class="project-list-item-content">
                                            <div
                                                class="project-text ion-display-flex ion-align-items-start ion-flex-column"
                                                style="flex: 1; min-width: 0"
                                            >
                                                <span class="project-name">{{ item.name }}</span>
                                                <span class="project-address project-name">{{
                                                    buildProjectAddressString($any(item).projectAddress)
                                                }}</span>
                                            </div>
                                            <ion-chip
                                                class="chip-project-number"
                                                color="primary"
                                                outline="true"
                                                slot="end"
                                                *ngIf="$any(item).projectNumber"
                                                [ngClass]="!item.synced ? 'dp-mr-l' : ''"
                                            >
                                                <fa-icon [icon]="['fal', 'hashtag']"></fa-icon>
                                                <ion-label>{{ $any(item).projectNumber }}</ion-label>
                                            </ion-chip>
                                            <div class="project-list-sync-icon" *ngIf="!item.synced">
                                                <fa-icon icon="cloud-arrow-up"></fa-icon>
                                            </div>
                                        </div>
                                    </div>
                                </ion-item>
                            }
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                    <ng-container *ngIf="!searchActive && currentVisibleProjects.length == 0 && currentVisibleProjectFolders.length == 0">
                        @if (currentFolderPath?.length > 0) {
                            <app-info-bar>
                                <div class="dp-mb-s">
                                    <strong>{{ 'dashboard.projects.folder.empty-folder' | translate }}</strong>
                                </div>
                                <div *ngIf="managementChangesAllowed">
                                    {{ 'dashboard.projects.folder.empty-folder-message' | translate }}
                                </div>
                            </app-info-bar>
                        } @else {
                            <app-info-bar>
                                <div class="dp-mb-s">
                                    <strong>{{ 'dashboard.projects.empty-list' | translate }}</strong>
                                </div>
                                <ng-container *ngIf="managementChangesAllowed">
                                    <div>{{ 'dashboard.projects.empty-list-message' | translate }}</div>
                                    <div class="dp-mt-m">
                                        <ion-button routerLink="/new-project">
                                            <fa-icon icon="plus" slot="start"></fa-icon>
                                            {{ 'dashboard.projects.empty-list-create-new' | translate }}
                                        </ion-button>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!managementChangesAllowed">
                                    <div>{{ 'dashboard.projects.none-assigned' | translate }}</div>
                                </ng-container>
                            </app-info-bar>
                        }
                    </ng-container>

                    <ng-container *ngIf="searchActive && currentVisibleProjects.length == 0 && currentVisibleProjectFolders.length == 0">
                        <app-info-bar>
                            <div class="dp-mb-s">
                                <strong>
                                    <fa-icon icon="align-slash" class="dp-mr-s"></fa-icon>
                                    {{ 'dashboard.projects.filter.empty-result' | translate }}</strong
                                >
                            </div>
                            <div>
                                {{ 'dashboard.projects.filter.empty-result-message' | translate }}
                            </div>
                        </app-info-bar>
                    </ng-container>
                </div>
            </ng-container>
        </ion-card-content>
    </ion-card>
    @if (mode === 'multi-select') {
        <ion-footer>
            <ion-toolbar color="none">
                <ion-buttons slot="end">
                    <ion-button color="primary" fill="solid" (click)="onConfirmMultiSelection()">
                        <fa-icon icon="check" slot="start"></fa-icon>
                        {{ 'shared.confirm' | translate }}
                        <ion-badge *ngIf="currentSelectedProjectIds.size > 0" color="light" class="dp-ml-s">
                            {{ currentSelectedProjectIds.size }}
                        </ion-badge>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-footer>
    }
</ng-template>

<!-- NEW FOLDER POPOVER -->
<ion-popover reference="event" #editFolderPopover>
    <ng-template>
        <ion-content class="ion-padding">
            <ion-input
                type="text"
                fill="outline"
                mode="md"
                [label]="'dashboard.projects.folder.new.placeholder' | translate"
                labelPlacement="floating"
                [placeholder]="'dashboard.projects.folder.new.title' | translate"
                [(ngModel)]="editFolderName"
                (keyup.enter)="onConfirmCurrentFolderEdit()"
                #editFolderNameInput
            ></ion-input>
            <div class="dp-mt-s ion-text-center">
                <ion-button color="primary" fill="solid" (click)="onConfirmCurrentFolderEdit()">
                    <ion-label *ngIf="currentlyCreatingNewFolder">{{ 'dashboard.projects.folder.actions.create' | translate }} </ion-label>
                    <ion-label *ngIf="!currentlyCreatingNewFolder">{{ 'dashboard.projects.folder.actions.save' | translate }} </ion-label>
                </ion-button>
            </div>
        </ion-content>
    </ng-template>
</ion-popover>

<!-- MAP MODAL -->
<ion-modal [isOpen]="mapViewEnabled" (ionModalDidDismiss)="mapViewEnabled = false" class="modal-l map-modal">
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title>{{ 'header.nav.projects' | translate }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="primary" (click)="mapViewEnabled = false">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <app-project-map (onProjectClicked)="mapViewEnabled = false"></app-project-map>
        </ion-content>
    </ng-template>
</ion-modal>

<!-- SCANNER MODAL -->
<ion-modal [isOpen]="scanSearchEnabled" (ionModalDidDismiss)="scanSearchEnabled = false" class="scanner-modal">
    <ng-template>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ 'dashboard.scan.title' | translate }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <app-code-scanner
            [isEnabled]="scanSearchEnabled"
            containerType="modal"
            (onScanResult)="onScanResult($event)"
            (onScanCancel)="scanSearchEnabled = false"
        ></app-code-scanner>
    </ng-template>
</ion-modal>

<!-- DOKUPIT SUPPORT PROJECT LIST -->
<ng-container *ngIf="isDokuPitSupportAccount">
    <ion-modal
        [isOpen]="supportProjectListModalVisible"
        (ionModalDidDismiss)="supportProjectListModalVisible = false"
        [style]="utils.isPhone ? '' : '--height: 100vh'"
    >
        <ng-template>
            <ion-header>
                <ion-toolbar color="none">
                    <ion-title>{{ 'dashboard.support-mode.project-list.title' | translate }}</ion-title>
                    <ion-buttons slot="end">
                        <ion-button fill="clear" shape="round" color="primary" (click)="supportProjectListModalVisible = false">
                            <fa-icon slot="icon-only" icon="times"></fa-icon>
                        </ion-button>
                    </ion-buttons>
                </ion-toolbar>
            </ion-header>
            <ion-content>
                <app-loading-indicator *ngIf="supportProjectLoading"
                    >{{ 'dashboard.support-mode.project-list.loading' | translate }}
                </app-loading-indicator>
                <ng-container *ngIf="!supportProjectLoading">
                    <ion-searchbar
                        [placeholder]="'dashboard.support-mode.project-list.search-placeholder' | translate"
                        [debounce]="500"
                        (ionInput)="supportSearchChanged($event, supportProjectSearchbar)"
                        #supportProjectSearchbar
                    ></ion-searchbar>
                    <ion-list *ngFor="let supportProjectInfo of visibleSupportProjectList">
                        <ion-item [detail]="utils.isPhone" (click)="downloadSupportProject(supportProjectInfo._id)">
                            <ng-container *ngIf="!utils.isPhone; else phoneLayout">
                                <ion-label tabindex="0" class="ion-text-wrap">
                                    {{ supportProjectInfo.name }}
                                    <span class="project-address">
                                        {{ buildProjectAddressString(supportProjectInfo.projectAddress) }}
                                    </span>
                                </ion-label>
                                <ion-chip
                                    class="project-number-chip"
                                    color="primary"
                                    outline="true"
                                    *ngIf="supportProjectInfo.projectNumber"
                                >
                                    <fa-icon [icon]="['fal', 'hashtag']"></fa-icon>
                                    <ion-label>{{ supportProjectInfo.projectNumber }}</ion-label>
                                </ion-chip>
                                <ion-chip color="primary" slot="end">
                                    <fa-icon icon="cloud-download"></fa-icon>
                                    <span class="ion-padding-start"> {{ 'shared.download' | translate }} </span>
                                </ion-chip>
                            </ng-container>
                            <ng-template #phoneLayout>
                                <ion-label tabindex="0" class="ion-text-wrap"> {{ supportProjectInfo.name }}</ion-label>
                                <ion-chip
                                    class="project-number-chip"
                                    color="primary"
                                    outline="true"
                                    *ngIf="supportProjectInfo.projectNumber"
                                >
                                    <fa-icon [icon]="['fal', 'hashtag']"></fa-icon>
                                    <ion-label>{{ supportProjectInfo.projectNumber }}</ion-label>
                                </ion-chip>
                            </ng-template>
                        </ion-item>
                    </ion-list>
                </ng-container>
            </ion-content>
        </ng-template>
    </ion-modal>
</ng-container>

<!-- SEARCH RESULT DIALOG FOR JOB SEARCH (SCANNER) -->
<ion-modal [isOpen]="jobSearchModalVisible" (ionModalDidDismiss)="jobSearchModalVisible = false" #jobSearchModal>
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title>{{ 'dashboard.scan.results-title' | translate: { search: lastJobSearchString } }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="primary" (click)="onCancelScanSearchResult()">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <app-loading-indicator *ngIf="jobSearchLoading"
                >{{ 'dashboard.scan.searching' | translate: { search: lastJobSearchString } }}
            </app-loading-indicator>
            <ng-container *ngIf="!jobSearchLoading && (lastJobSearchResult == null || lastJobSearchResult.length == 0)">
                <div class="dp-notice">
                    <div class="notice-header">
                        <div class="notice-title">{{ 'dashboard.scan.no-results' | translate }}</div>
                    </div>
                    <div class="notice-content ion-text-center">
                        {{ 'dashboard.scan.no-results-message' | translate }}
                        <div class="dp-mt-s">
                            <ion-button fill="clear" color="warning" (click)="onCancelScanSearchResult()"
                                >{{ 'shared.cancel' | translate }}
                            </ion-button>
                            <ion-button (click)="onStartNewSearch()">
                                <fa-icon icon="qrcode" slot="start"></fa-icon>
                                {{ 'dashboard.scan.restart-btn' | translate }}
                            </ion-button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ion-list *ngIf="!jobSearchLoading && lastJobSearchResult != null">
                <ion-item
                    detail
                    *ngFor="let searchResult of lastJobSearchResult"
                    (click)="onGoToSearchResult(searchResult, jobSearchModal)"
                >
                    <ion-label>
                        {{ searchResult.job.jobNumber + ' - ' + searchResult.job.name }}
                        <div class="ion-text-wrap">
                            <small>{{ searchResult.project.name }}</small>
                        </div>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ng-template>
</ion-modal>

<!-- FOLDER SELECTION MODAL FOR MANUAL ITEM MOVING -->
<ion-modal
    [isOpen]="chooseFolderMoveTargetModalVisible"
    (ionModalDidDismiss)="chooseFolderMoveTargetModalVisible = false"
    class="modal-m mobile-fullscreen"
>
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title> {{ 'dashboard.projects.move-to-folder' | translate }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="primary" (click)="chooseFolderMoveTargetModalVisible = false">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content [scrollY]="false">
            <app-project-list
                style="height: 100%"
                [mode]="'select-folder'"
                (folderSelectionChanged)="finishManualItemToFolderMove($event)"
            ></app-project-list>
        </ion-content>
    </ng-template>
</ion-modal>

<!-- PROJECT DUPLICATE MODAL -->
<ion-modal [isOpen]="duplicateModalVisible" (ionModalDidDismiss)="duplicateModalVisible = false" class="modal-s stack-modal">
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title> {{ 'dashboard.projects.duplicate-project' | translate }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="primary" (click)="duplicateModalVisible = false">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content [scrollY]="false">
            <ion-col>
                <ion-card class="duplicate-project-setting duplicate-project-setting-active ion-align-items-center dp-mt-s">
                    <div class="duplicate-project-setting-content">
                        <div>
                            <ion-card-header>
                                <ion-card-title>{{ 'dashboard.projects.duplicate-project' | translate }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                {{ 'dashboard.projects.duplicate-project-desc' | translate }}
                            </ion-card-content>
                        </div>
                        <div class="duplicate-project-setting-icon">
                            <fa-icon icon="check-circle" class="color-success" size="lg"></fa-icon>
                        </div>
                    </div>
                </ion-card>
                <ion-card
                    class="duplicate-project-setting ion-align-items-center dp-mt-s"
                    (click)="copyJobs = !copyJobs"
                    [ngClass]="copyJobs ? 'duplicate-project-setting-active' : 'duplicate-project-setting-not-active'"
                >
                    <div class="duplicate-project-setting-content">
                        <div>
                            <ion-card-header>
                                <ion-card-title>{{ 'dashboard.projects.duplicate-project-jobs' | translate }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                {{ 'dashboard.projects.duplicate-project-jobs-desc' | translate }}
                            </ion-card-content>
                        </div>
                        <div class="duplicate-project-setting-icon">
                            <fa-icon icon="check-circle" class="color-success" size="lg"></fa-icon>
                        </div>
                    </div>
                </ion-card>
            </ion-col>
        </ion-content>
        <ion-footer>
            <ion-toolbar color="none">
                <ion-buttons slot="end">
                    <ion-button color="success" fill="solid" (click)="startProjectCopyProcess()" [dpIsLoading]="copyLoading">
                        <fa-icon icon="check" slot="start"></fa-icon>
                        {{ 'shared.duplicate' | translate }}
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-footer>
    </ng-template>
</ion-modal>

<!-- CONTEXT MENU FOR FOLDER -->
<ng-template #templateContextMenuFolder let-contextData>
    @if (managementChangesAllowed) {
        <div class="template-context-menu-folder" cdkMenu>
            <button class="template-context-menu-item" cdkMenuItem (click)="startManualItemToFolderMove(contextData.data)">
                <fa-icon icon="angles-up-down" class="dp-mr-s"></fa-icon>
                {{ 'dashboard.projects.move-to-folder' | translate }}
            </button>
            <button class="template-context-menu-item" cdkMenuItem (click)="onMoveItemToBase(contextData.data)">
                <fa-icon icon="angles-up" class="dp-mr-s"></fa-icon>
                {{ 'dashboard.projects.remove-from-folder' | translate }}
            </button>
            <button class="template-context-menu-item" cdkMenuItem (click)="onCreateNewFolder(contextData.anchor)">
                <fa-icon icon="folder-plus" class="dp-mr-s"></fa-icon>
                {{ 'dashboard.projects.toolbar.add-folder' | translate }}
            </button>
            <button class="template-context-menu-item" cdkMenuItem (click)="onEditFolder(contextData.data, contextData.anchor)">
                <fa-icon icon="pen-to-square" class="dp-mr-s"></fa-icon>
                {{ 'projects.info.folder.rename-folder' | translate }}
            </button>
            <button class="template-context-menu-item color-danger" cdkMenuItem (click)="onDeleteFolder(contextData.data)">
                <fa-icon icon="trash" class="dp-mr-s"></fa-icon>
                {{ 'projects.info.folder.delete-folder' | translate }}
            </button>
        </div>
    }
</ng-template>
<!-- CONTEXT MENU FOR PROJECTS -->
<ng-template #templateContextMenuProject let-contextData>
    <div class="template-context-menu-project" cdkMenu>
        @if (managementChangesAllowed) {
            <button class="template-context-menu-item" cdkMenuItem (click)="startManualItemToFolderMove(contextData.data)">
                <fa-icon icon="angles-up-down" class="dp-mr-s"></fa-icon>
                {{ 'dashboard.projects.move-to-folder' | translate }}
            </button>
            <button class="template-context-menu-item" cdkMenuItem (click)="onMoveItemToBase(contextData.data)">
                <fa-icon icon="angles-up" class="dp-mr-s"></fa-icon>
                {{ 'dashboard.projects.remove-from-folder' | translate }}
            </button>
            <button class="template-context-menu-item" cdkMenuItem (click)="onCreateNewFolder(contextData.anchor)">
                <fa-icon icon="folder-plus" class="dp-mr-s"></fa-icon>
                {{ 'dashboard.projects.toolbar.add-folder' | translate }}
            </button>
            @if (contextData.data.projectStatus == possibleProjectStatus.INPROGRESS) {
                <button
                    class="template-context-menu-item"
                    cdkMenuItem
                    (click)="onStartDuplicatingProject(contextData.data)"
                    [disabled]="projSrv.projectCurrentlyDeleting"
                >
                    <fa-icon icon="copy" class="dp-mr-s"></fa-icon>
                    {{ 'dashboard.projects.duplicate-project' | translate }}
                </button>
                <button
                    class="template-context-menu-item"
                    cdkMenuItem
                    (click)="onArchiveProject(contextData.data)"
                    [disabled]="projSrv.projectCurrentlyDeleting"
                >
                    <fa-icon icon="archive" class="dp-mr-s"></fa-icon>
                    {{ 'dashboard.projects.archive-project' | translate }}
                </button>
                <button
                    class="template-context-menu-item color-danger"
                    cdkMenuItem
                    (click)="onDeleteProject(contextData.data)"
                    [disabled]="projSrv.projectCurrentlyDeleting"
                >
                    <fa-icon icon="trash" class="dp-mr-s"></fa-icon>
                    {{ 'dashboard.projects.delete-project' | translate }}
                </button>
            }
        }
    </div>
</ng-template>
